module.exports = __webpack_public_path__ + "statics/img/01.b8305e58.jpg";